import styled from "styled-components";
import { ExButton } from "../../../components/ExButton";

export const Container = styled.div`
    background-color: var(--background-color);
`;

export const RowMain = styled.div`
    padding: 10px;
        transition: background-color 0.3s;

    &:hover {
        background-color: #f0f0f010; // cor de destaque ao passar o mouse
        cursor: pointer; // opcional: muda o cursor para indicar interatividade
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const RowChild = styled.div`
    overflow: hidden;
    transition: max-height .3s ease-in-out;
    margin-left: 20px;
`;

export const ExpandButton = styled(ExButton)`
    display: flex;
    justify-content: center;
    margin-right: 38px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
`;

export const ExtraButton = styled(ExButton)`
    display: flex;
    justify-content: center;
    margin-right: 38px;
    height: 24px;
    padding: 0;
`;

export const GrupoDescription = styled.span<{ haschilds: boolean }>`
    margin-left: ${(props) => (props.haschilds ? 0 : '68px')};
    margin-right: 15px;
    min-height: 30px;
    line-height: 30px;
`;
